import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormToggleField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'checkbox-field-component',
    templateUrl: './checkbox-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeCheckboxFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormToggleField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    constructor() { }

    get checked() {
        return this.field.control.value;
    }

    set checked(value: boolean) {
        if (!this.field.readonly) {
            this.field.control.setValue(value);
            this.field.control.markAsTouched();
        }
    }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
